import axios from 'axios'
import config from "config";
import history from "./history";
const baseUrl = `${config.apiUrl}`;

const axiosInstance = axios.create({
    withCredentials: true,
    baseURL: baseUrl,
})

// Переменные для управления очередью обновлений
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        if (error) prom.reject(error);
        else prom.resolve(token);
    });
    failedQueue = [];
};

// Функция для парсинга Blob ошибок
async function parseBlobError(blob) {
    try {
        const text = await blob.text();
        const json = JSON.parse(text);
        return json.message || 'Ошибка сервера';
    } catch {
        return 'Ошибка при обработке ответа сервера';
    }
}

axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // обновление токена
        if (error.response?.status === 401 && !originalRequest._retry) {
            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                })
                    .then((token) => {
                        originalRequest.headers['Authorization'] = `Bearer ${token}`;
                        return axiosInstance(originalRequest);
                    })
                    .catch((err) => Promise.reject(err));
            }

            originalRequest._retry = true;
            isRefreshing = true;

            try {
                // Выполняем обновление (используем прямой запрос, чтобы не вызвать рекурсию)
                const response = await axios.post(`${baseUrl}/Authorize/Refresh-Token`);
                const newToken = response.data.jwtToken;

                localStorage.setItem("accessToken", newToken);
                axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;

                processQueue(null, newToken);
                return axiosInstance(originalRequest);
            } catch (refreshError) {
                processQueue(refreshError, null);
                localStorage.removeItem("accessToken");
                history.push('/signin');
                return Promise.reject(refreshError);
            } finally {
                isRefreshing = false;
            }
        }

        if (!error.response) {
            return Promise.reject({ message: "Сервер недоступен или нет сети" });
        }

        if (error.response.data instanceof Blob && error.response.data.type === "application/json") {
            const message = await parseBlobError(error.response.data);
            return Promise.reject({ message });
        }

        if (error.response.data === "") {
            return Promise.reject({ message: "Некорректный запрос" });
        }

        if (error.response.data && typeof error.response.data === 'object') {
            const message = error.response.data.message || error.response.data.error || 'Ошибка на сервере';
            return Promise.reject({ message });
        }

        if (typeof error.response.data === 'string') {
            return Promise.reject({ message: error.response.data });
        }

        return Promise.reject({ message: 'Что-то пошло не так' });
    }
);

export default axiosInstance